import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../constants/Header";
import { setFilters } from "../../redux/filters";
import { Box, CircularProgress, Grid, Typography } from "@material-ui/core";
import Searchbar from "../../constants/Searchbar";
import { useHistory, useParams } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { getResultsMap } from "./network_requests";
import TopFilterButton from "./TopFilterButton";

function PortfolioMap({ t }) {
  const states = useSelector((state) => state.states.value);
  const filters = useSelector((state) => state.filters.value);
  const history = useHistory();
  let { tab, query } = useParams();

  const dispatch = useDispatch();
  const [load, setLoad] = useState(false);
  const [isServerDown, setIsServerDown] = useState(false);
  const [resultMap, setResultMap] = useState([]);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const [isFixedHeader, setIsFixedHeader] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const y = window.pageYOffset;
      setIsFixedHeader(y > 280 ? true : false);
    });
  });

  useEffect(async () => {
    setLoad(true);
    setResultMap([]);
    const data = await getResultsMap(query);
    if (data === "error") {
      setIsServerDown(true);
    } else {
      dispatch(setFilters({}));
      setIsServerDown(false);
      setResultMap(data);
    }
    setLoad(false);
  }, [query]);

  return (
    <div style={{ minHeight: "100vh", maxWidth: "100%", overflowX: "hidden" }}>
      {isFixedHeader ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              zIndex: 500,
              left: 0,
              width: "100%",
            }}
          >
            <Header fixed={true} placeHolder={t("search_placeholder")} t={t} />
          </div>
        </>
      ) : null}
      <div
        style={{
          position: isDesktopOrLaptop ? "absolute" : "",
          width: "100%",
          left: 0,
          top: 0,
        }}
      >
        <Header placeHolder={t("search_placeholder")} t={t} />
        <div
          style={{
            padding: isDesktopOrLaptop ? 0 : "14px 15px 0px 11px",
            backgroundColor: "#f8f8f8",
            paddingBottom: "10px",
            marginBottom: "25px",
          }}
        >
          {!isDesktopOrLaptop ? <Searchbar unfocused={true} /> : null}
        </div>
      </div>
      {isDesktopOrLaptop ? <div style={{ height: "153px" }} /> : null}

      <Grid
        style={{
          marginBottom: "25px",
        }}
      >
        <Typography
          style={{
            fontFamily: "Overpass",
            color: "black",
            fontSize: "18px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {t("searched-for")}{" "}
          <span style={{ color: "#0040ff", fontWeight: "bold" }}>{query}</span>{" "}
        </Typography>
        <Typography
          style={{
            fontFamily: "Overpass",
            color: "#808080",
            textAlign: "center",
          }}
        >
          {t("portfolio-title")}
        </Typography>
      </Grid>
      <Grid container justifyContent="center">
        <Grid
          style={{
            width: "80%",
            margin: 0,
            padding: 0,
            textAlign: "center",
          }}
        >
          {resultMap?.map((value) => {
            return <TopFilterButton value={value} />;
          })}
        </Grid>
      </Grid>
      {load ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "20vh",
          }}
        >
          <CircularProgress style={{ color: "#808080" }} />
        </div>
      ) : isServerDown ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={isDesktopOrLaptop ? 6 : 10}>
            <p
              style={{
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "38px" : "26px",
                fontWeight: "bold",
                color: "#16063b",
                textAlign: "center",
                marginTop: "45px",
              }}
            >
              {t("server_down")} 😔
            </p>
          </Grid>
        </div>
      ) : null}
    </div>
  );
}

export default withNamespaces()(PortfolioMap);
